import React,{Component} from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import NumberFormat from 'react-number-format';
import CircularProgress from '@material-ui/core/CircularProgress';
import {history} from '../../../shared/configure-store';
import {toast, ToastContainer} from 'react-toastify';
import { withRouter, Link } from 'react-router-dom';
import Api from '../../../libraries/api';
import language from '../../../libraries/label-lang';
import {bindActionCreators} from 'redux';
import {RootActions} from '../../../shared/root-action';
import {connect} from 'react-redux';
import moment from "moment/moment";

class Transactions extends Component {

    constructor(props) {

        super(props);

        this.state = {
            loading: false,
            loadingButton: false,

            errors: [],

            showDialog: false,

            rows: [],

            currentMonth: '',
            month: null,
        };
    }

    componentDidMount(){

        document.title = 'Fresh Factory - Riwayat';
        this.setState({
            month: moment().format('MM'),
        }, () => this.__fetchData());
    };

    __fetchData = () => {

        let month = moment().format('YYYY')+'-'+this.state.month+'-01';

        Api.get('/expenses/daily_summary?month='+month).then(resp => {
            if (resp.data) {

                this.setState({
                    rows: resp.data,
                    loading: false,
                })

            }
        }).catch(err => {
            console.log(err);

            this.setState({
                    loading: true,
                }
            );

        });
    };

    handleChange (e, prop){

        this.setState({

            [prop]: e.target.value

        }, () => {
            this.__fetchData();
        })

    };

    handleGo  = (link) => {
        history.push(link);
    };

    handleInvoice  = () => {
        let month = moment().format('YYYY')+'-'+this.state.month+'-01';
        history.push('/histories/invoice/'+month);
    };

    showMessage = (status, message) => {
        if(status) {
            toast.success(message, {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        }else {
            toast.error(message, {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        }
    };

    render() {
        let lang = {};
        if(this.props.toggle_set_lang === 'indo') {
            lang = language.id;
        }else {
            lang = language.en;
        }
        const text = lang;

        return (

            <div className='dashboard-detail'>
                <nav aria-label='breadcrumb'>
                    <ol className='breadcrumb'>
                        <li className='breadcrumb-item'><Link to='/' >{text.label_dashboard}</Link></li>
                        <li className='breadcrumb-item'><Link to='/histories' >{text.label_history}</Link></li>
                        <li className='breadcrumb-item active' aria-current='page'>Catatan Biaya</li>
                    </ol>
                </nav>
                <h2 className='text-uppercase'>Catatan Biaya</h2>

                <div className='clearfix'> </div>
                <div className='row align-items-center'>
                    <div className='col-6 col-md-4'>
                        <div className='form-group'>
                            <TextField
                                select
                                variant="outlined"
                                id='month'
                                name='month'
                                label='Bulan'
                                onChange={(e) => this.handleChange(e, 'month')}
                                value={this.state.month === null ? this.state.currentMonth : this.state.month}
                                fullWidth
                            >
                                <MenuItem value='01'>Januari</MenuItem>
                                <MenuItem value='02'>Februari</MenuItem>
                                <MenuItem value='03'>Maret</MenuItem>
                                <MenuItem value='04'>April</MenuItem>
                                <MenuItem value='05'>Mei</MenuItem>
                                <MenuItem value='06'>Juni</MenuItem>
                                <MenuItem value='07'>Juli</MenuItem>
                                <MenuItem value='08'>Agustus</MenuItem>
                                <MenuItem value='09'>September</MenuItem>
                                <MenuItem value='10'>Oktober</MenuItem>
                                <MenuItem value='11'>November</MenuItem>
                                <MenuItem value='12'>Desember</MenuItem>
                            </TextField>
                        </div>
                    </div>
                    <div className='col-6 col-md-4'>
                        <div className='form-group'>
                            <Button
                                variant='contained'
                                color='primary'
                                className=''
                                onClick={() => this.handleInvoice()}
                                disabled={this.state.loadingButton && 'disabled' }
                            >
                                Invoice{ this.state.loadingButton && <i className='fa fa-spinner fa-spin'> </i> }
                            </Button>
                        </div>
                    </div>


                </div>
                <div className='table-wrapper'>
                    <Table className='table-list' size='small' >
                        <TableHead>
                            <TableRow>
                                <TableCell className='clickable' onClick={() => this.handleSort('name')} >Tanggal</TableCell>
                                <TableCell className='clickable'  >Isi Saldo</TableCell>
                                <TableCell className='clickable' onClick={() => this.handleSort('skuNumber')} >Total Tagihan</TableCell>
                                <TableCell className='clickable' onClick={() => this.handleSort('storage')} >Kredit Teserdia</TableCell>
                                <TableCell className='clickable' onClick={() => this.handleSort('storage')} >Saldo</TableCell>
                                <TableCell></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {this.state.loading ? (
                                <TableRow>
                                    <TableCell colSpan={5} align='center' className='py-5'>
                                        <CircularProgress color='primary'  />
                                    </TableCell>
                                </TableRow>
                            ) : (
                                this.state.rows.length === 0 ? (
                                    <TableRow style={{ height: 33 * 5}}>
                                        <TableCell colSpan={5} style={{ textAlign: 'center' }}>{text.label_no}</TableCell>
                                    </TableRow>
                                ) : (
                                    this.state.rows.map((row, idx) => (
                                        <TableRow
                                            key={idx}
                                            selected={row.selected}>
                                            <TableCell>{row.transaction_date}</TableCell>
                                            <TableCell>
                                                Rp <NumberFormat thousandSeparator={'.'} decimalSeparator={','} fixedDecimalScale={false}
                                                                 decimalScale={0} value={parseFloat(row.topup)} displayType={'text'} renderText={value => value} />
                                            </TableCell>
                                            <TableCell>
                                                Rp <NumberFormat thousandSeparator={'.'} decimalSeparator={','} fixedDecimalScale={false}
                                                                 decimalScale={0} value={parseFloat(row.billing)} displayType={'text'} renderText={value => value} />
                                            </TableCell>
                                            <TableCell>
                                                Rp <NumberFormat thousandSeparator={'.'} decimalSeparator={','} fixedDecimalScale={false}
                                                                 decimalScale={0} value={parseFloat(row.available_credit)} displayType={'text'} renderText={value => value} />
                                            </TableCell>
                                            <TableCell>
                                                Rp <NumberFormat thousandSeparator={'.'} decimalSeparator={','} fixedDecimalScale={false}
                                                                 decimalScale={0} value={parseFloat(row.balance)} displayType={'text'} renderText={value => value} />
                                            </TableCell>
                                            <TableCell>
                                                <Link to={'/histories/detail/' + row.transaction_date} className='btn-icon mr-2'>
                                                    Detail
                                                </Link>
                                            </TableCell>
                                        </TableRow>
                                    ))
                                )
                            )}

                        </TableBody>
                    </Table>
                </div>

               {/* <TablePagination
                    rowsPerPageOptions={[10, 25, 50]}
                    component='div'
                    count={this.state.total}
                    rowsPerPage={this.state.perPage}
                    page={this.state.currentPageTable}
                    backIconButtonProps={{
                        'aria-label': 'previous page',
                    }}
                    nextIconButtonProps={{
                        'aria-label': 'next page',
                    }}
                    onChangePage={this.handleChangePage}
                    onChangeRowsPerPage={this.handleChangeRowsPerPage}
                    ActionsComponent={TablePaginationActions}
                />*/}

                <Dialog
                    maxWidth='sm'
                    fullWidth={true}
                    open={this.state.showDialog}
                    onClose={this.handleClose}
                    aria-labelledby='form-dialog-title'>
                    <DialogTitle id='form-dialog-title'>DELETE PROJECT: {this.state.currDelete}</DialogTitle>
                    <DialogContent>
                        <p>{text.text_delete}</p>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            variant='contained'
                            className='mr-3'
                            onClick={this.handleClose}
                        >
                            {text.button_cancel}
                        </Button>
                        <Button
                            variant='contained'
                            color='primary'
                            className=''
                            onClick={this.handleDelete}
                            disabled={this.state.loadingButton && 'disabled' }
                        >
                            {text.button_delete}{ this.state.loadingButton && <i className='fa fa-spinner fa-spin'> </i> }
                        </Button>
                    </DialogActions>
                </Dialog>

                <ToastContainer />
            </div>

        )

    }
}

const mapStateToProps = (state) => {

    return {

        toggle_set_lang: state.toggle_set_lang,

    };

};

const mapDispatchToProps = (dispatch) => {

    return bindActionCreators(RootActions, dispatch)

};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Transactions));